import "./selection/index.js";
export { default as transition } from "./transition/index.js";
export { default as active } from "./active.js";
export { default as interrupt } from "./interrupt.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-transition/src/index.js
// module id = 506
// module chunks = 0